import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import app from '../../../plugins/routes/app';
import { connect } from 'react-redux';

import Profile from "./Account/Profile"

class Trip extends Component {

    render() {
        let accounts = app.routes.find(x => x.name === 'accounts');
        return (
            <Switch>
                <Route exact path="/app/accounts" component={Profile} />
                {accounts.routes.map((route, key) => {
                    return <Route
                        path={`${app.path}${accounts.path}${route.path}`}
                        meta={route.meta}
                        component={route.component}
                        key={key}
                    />;
                })}
            </Switch>
        )
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Trip);


// WEBPACK FOOTER //
// ./src/components/App/Views/Account.js